import React from "react";
import dayjs from 'dayjs';
import Calendar from "Components/Calendar";
import api from "../../utils/api";
import utils from "../../utils";
import { Col, Row, message} from "antd";
import "./Appointment.scss";
import { connect } from "react-redux";
import { historyState } from "../../store/slice/history-slice";
import Loader from "Components/Loader";
import { CONSTANTS } from "utils/constant";
import ModalPopupComponent from "Components/ModalPopupComponent";
import CommonButton from "Components/CommonButton";
import { withTranslation, Trans } from 'react-i18next';
import { PRIMARY_LANG, LANG_STYLD_EXT, TS_STYLD_COMPS } from "Common/constant";
import { t } from "i18next";
import { setActivePlan } from "store/slice/login-slice";
class SelectSlots extends React.Component {
  _baseClassName = "schedule-appointment-container";
  constructor(props) {
    super(props);
    this.state = {
      user_details: this.props.user_details,
      slotData: [],
      slot_details: [],
      flag: false,
      doctorSelectedData : this.props.doctorSelectedData
    };
  }
  handleSlotSelection(value) {
    this.setState({
      selectedSlot: value,
      showTimeSlotWarning: false,
    });
  }
  handleBookAppointment() {
    var datetime = {
      appointment_date_time: this.state.selectedSlot,
      clinician_id: this.props.patient_status?.profile?.care_standard == "niyama"  && this.props.patient_status?.appointment?.is_first_time_appointment ? undefined : this.props.doctorID,
      order_id:this.props.activeCarePlan?.order_id,
    };
    this.props.setActivePlan(null);
    this.setState({ isLoading: true });
    this.props.handleSlotsLoader(true);
      api
        .schedule_book_appointment(datetime)
        .then((response) => {
          if (response.data?.status == 200) {
            api.confirmed_appointment_detail({ appointment_id: response.data?.data?.appointment_id || "" })
              .then((res) => {
                if (res.data?.status == 200) {
                  typeof this.props?.appointmentBookedUpdateStep == "function" && this.props?.appointmentBookedUpdateStep(3, {...res.data.data.appointment, ...res.data.data.clinician});
                } else {
                  message.error(res.data.message, ErrorDuration);
                }
              })
          } else if (response.data?.status == 400) {
            utils.Toast({ type: "error", message: response.data?.message });
          }
        })
        .catch((err) => {
        }).finally(() => {
          this.setState({ isLoading: false });
          this.props.handleSlotsLoader(false)
        });
    utils.Modal(false);
  }
  handleAvailabilityConformationPopup(){
    const tgtLang = this.props.includePrimeLang
        ? this.props.i18n.language + "_" + PRIMARY_LANG
        : this.props.i18n.language;
    utils.Modal(true, {
      closable:false,
      content: <ModalPopupComponent title={t(CONSTANTS.APPOINTMENT_CONFORMATION,{lng: tgtLang})} 
      content={<><div>
        <p style={{wordBreak:"break-word"}}>
        {t(CONSTANTS.ARE_U_SURE, {lng: tgtLang})}  {this.state.doctorSelectedData.clinician_first_name ? "with "+ 
      utils.salutationPrefixName(this.state.doctorSelectedData?.salutation, utils.FormatName(
        utils.getDisplayName(this.state?.doctorSelectedData?.clinician_first_name, this.state?.doctorSelectedData?.clinician_last_name)), "200px")
        : ""}
    
      &nbsp;on {utils.FormatDate(
        this.state.selectedSlot,
        "DATE_14"
      )} at {utils.FormatDate(
        this.state.selectedSlot,
        "TIME_1"
      )}?
       </p> </div></>} button1={t(CONSTANTS.YES, {lng: tgtLang})} button2={t(CONSTANTS.NO, {lng: tgtLang})} 
      onclick1={this.handleBookAppointment.bind(this)} onclick2={() => utils.Modal(false)} 
      className1="common-button-green" className2="link-button-green"/>,
      width: "480px",
      })
  }
  componentDidMount() {
    this.setState({
      selectedDate: this.state?.doctorSelectedData?.next_available_date ? this.state?.doctorSelectedData?.next_available_date : utils.FormatDate(this.props.currentOffsetDateTime), isLoading:true   // get patient status date & time 
    });
    this.getAppointmentSlots(this.state?.doctorSelectedData?.next_available_date ? this.state?.doctorSelectedData?.next_available_date : this.props.currentOffsetDateTime);
  }
  getAppointmentSlots(formatedDate) {
    if(!(dayjs(this.props.currentOffsetDateTime).format('DD/MM/YYYY') == dayjs(formatedDate).format('DD/MM/YYYY'))){
      formatedDate = dayjs(formatedDate).format('YYYY-MM-DD 00:00:00')
    }
    api
      .schedule_appointment_available_slots({
        appointment_date_time: formatedDate,
        clinician_id: this.props.doctorID
      })
      .then((res) => {
        let response = res.data?.data;
        let newdata = Object.keys(response || {}).map((m) => {
          return {
            label: utils.Capitalize(m),
            slots: response[m],
          };
        });
        let flag = newdata.some((item) => item.slots?.length > 0);
        this.setState({
          slotData: newdata,
          isSlotsAvailable: flag,
          isLoading:false,
          slot_status:"finished"
        });
        if (res.data?.status == 400) {
          // utils.Toast({ type: "error", message: res.data?.message });
          this.setState({ selectedSlot: null });
        }
        typeof this.props.handleSlotsLoader == "function" &&
        this.props.handleSlotsLoader(false);
      });
  }
  handleDateSelection(value) {
    if(value < dayjs(this.props.currentOffsetDateTime).startOf("day") ||
    dayjs(this.props.currentOffsetDateTime).add(7, "days") <= value
    || value > dayjs(JSON.parse(localStorage.getItem("subscription"))?.plan_expiry_date)){
      return;
    }  
    let formatedDate = utils.FormatDate(value, "UTC", "days");
    if(this.state.selectedDate == formatedDate)
      return;
    this.setState({
      selectedDate: formatedDate,
      selectedSlot: undefined,
    });
    this.getAppointmentSlots(formatedDate); 
  }
 
  render() {
    const tgtLang = this.props.includePrimeLang
      ? this.props.i18n.language + "_" + PRIMARY_LANG
      : this.props.i18n.language;
    const tgtLangST = this.props.includePrimeLang ? tgtLang + LANG_STYLD_EXT : tgtLang;
    return (
      <div>
        {this.state.isLoading ? <Loader tgtLangST={tgtLangST}/> :
          <div className={this._baseClassName}>
            {/* <div style={{marginBottom:"10px"}} onClick={() =>{this.navigateBackPage(this)}} className="previous-page-button">{CONSTANTS.BACK_TO_PREVIOUS_PAGE}</div> */}
            <Row className="main-content">
            
                <div className={`main-content-body`}>
                  <div>
                    <div  className="left-content">
                    <div className="wrapper-header">
                      {/* <div className="round-circle"></div> */}
                      <div className="title-content"><Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.PICK_DATE, {lng: tgtLangST})}</Trans></div>
                      <div className="slected-date"><span className="selected-date-content">{utils.FormatDate(this.state.selectedDate, "DATE_9")}</span></div>

                    </div>
                    <div className=   "content-body">
                      <Calendar
                      style={{borderRadius:"0px !important"}}
                        onSelect={this.handleDateSelection.bind(this)}
                        defaultValue={dayjs(this.state?.doctorSelectedData?.next_available_date ? this.state?.doctorSelectedData?.next_available_date : this.props.currentOffsetDateTime)}    // get patient status date & time 
                        iconHide={true}
                        showToday={false}
                        disabledDate={(current) =>
                          current < dayjs(this.props.currentOffsetDateTime).startOf("day") ||
                          dayjs(this.props.currentOffsetDateTime).add(7, "days") <= current
                          || current > dayjs(JSON.parse(localStorage.getItem("subscription"))?.plan_expiry_date)
                        }
                      />
                    </div>
                    </div>
                  </div>
                  <div className="right-content">
                    <div className="wrapper-header">
                      {/* <div className="round-circle"></div> */}
                      <div className="title-content"><Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.CHOOSE_THE_TIME, {lng: tgtLangST})}</Trans></div>
                    </div>
                    <div className="content-body">
                      <div className="time-slot-container">
                        {!this.state.isSlotsAvailable ? <div className="no-slots-text"><Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.NO_SLOTS_AVAILABLE, {lng: tgtLangST})}</Trans></div> :
                            <>
                              {(this.state.slotData || [])
                              .filter(obj => obj["slots"].length > 0) 
                              .map((obj, i) => {
                                return (
                                  <div className="slots-group" key={i}>
                                    {obj["slots"].length > 0 ? <div className="slots-header">
                                      <div className="slots-label">
                                        {/* <img src={icons.star} /> &nbsp;  */}
                                        <Trans components={TS_STYLD_COMPS}>{t(obj["label"]+" Slots", {lng: tgtLangST})}</Trans>
                                      </div>
                                    </div> : ''}
                                    <div className="slots-container">
                                      {(obj["slots"] || []).map((slot, index) => {
                                        return (
                                          <div
                                            className={`slot${this.state.selectedSlot == slot
                                              ? " selected"
                                              : ""
                                              } ${dayjs(this.props.currentOffsetDateTime) > dayjs(slot) ? "disabled" : ""}
                                            ${dayjs(JSON.parse(localStorage.getItem("subscription"))?.plan_expiry_date) < dayjs(slot) ? "disabled" : ""}`}
                                            onClick={(e) => dayjs(this.props.currentOffsetDateTime) > dayjs(slot) ? "disabled" : "" || dayjs(JSON.parse(localStorage.getItem("subscription"))?.plan_expiry_date) < dayjs(slot) ? undefined : this.handleSlotSelection(slot)}
                                            key={index}
                                          >
                                            {utils.FormatDate(slot, "TIME_5")}
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </div>
                                );
                              })}
                            </>
                        }
                      </div>
                    </div>
                  </div>
                  {/* )} */}
                </div>
                <Row className="bottom-content">
                  <Col>
                    <CommonButton className="common-button-green" label={t(CONSTANTS.NEXT_CAP, {lng: tgtLang})} onClick ={()=>this.handleAvailabilityConformationPopup()} disabled={this.state.selectedSlot == undefined ? "disabled" : ""}  style={this.state.selectedSlot ? { cursor: "pointer" } : { cursor: "default" }}/>
                  </Col>
                </Row>
            </Row>
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user_details: state.loginReducer.user_details,
    includePrimeLang: state.loginReducer.includePrimeLang,
    activeCarePlan:state.loginReducer.activeCarePlan,
  }
}
const mapDispatchToProps = {
  historyState,
  setActivePlan,
}
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SelectSlots));